import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import i18n from '../../src/i18n/translate';

export default class Details extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
    fields: PropTypes.array.isRequired
  };

  render() {
    return (
      <div className="container">
        <h2>{this.props.title}</h2>
        <dl className="dl-horizontal">
          {this.props.fields.map((field) => {
            return (
              <div key={field.name}>
                <dt>{field.title}</dt>
                <dd>{this.props.data[field.name]}</dd>
              </div>
            );
          })}
        </dl>
        <Link className="btn btn-primary" to="/">{i18n.t('Back')}</Link>
      </div>
    );
  }
}
